import { SdgRoutes } from '@igo2/sdg-common';

export const authRoutes: SdgRoutes = [
  { path: '', redirectTo: '/login', pathMatch: 'full', hidden: true },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'redirect',
    loadComponent: () =>
      import('./redirect').then((m) => m.MspAuthRedirectComponent)
  }
];
